module.exports = __webpack_public_path__ + "img/tu_schedule_match_active.ba47de24.svg";